import script from "./AlertsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsView.vue?vue&type=script&setup=true&lang=js"

import "./AlertsView.vue?vue&type=style&index=0&id=6e714cb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e714cb4"]])

export default __exports__